import { ComponentType } from '@angular/cdk/portal';
import { Component, computed, inject, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { VisualEvent } from '@core/interfaces/visual-event';
import { ImageGridComponent } from '@shared/components/image-grid/image-grid.component';
import { DialogService } from 'osc-reference-app-common';
import { VisualEventImageViewerComponent } from '../visual-event-image-viewer/visual-event-image-viewer.component';

@Component({
  selector: 'app-photo-gallery',
  templateUrl: './photo-gallery.component.html',
  styleUrls: ['./photo-gallery.component.scss'],
  imports: [TranslateModule, ImageGridComponent],
})
export class PhotoGalleryComponent {
  #dialogService = inject(DialogService);

  // eslint-disable-next-line @angular-eslint/no-input-rename
  public visualEvents = input.required<VisualEvent[]>({ alias: 'images' });
  public images = computed(() => {
    const images = new Map<string, { src: string }>();
    for (const ve of this.visualEvents()) {
      for (const img of ve.images) {
        images.set(img.fileId, { src: img.imageUrl });
      }
    }
    return Array.from(images.values());
  });

  public openImage(url: string): void {
    this.#dialogService.openXlDialog(VisualEventImageViewerComponent as ComponentType<VisualEventImageViewerComponent>, {
      url,
    });
  }
}
